"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildTxToSign = void 0;
const chain_adapters_1 = require("@shapeshiftoss/chain-adapters");
const web3_utils_1 = require("web3-utils");
const buildTxToSign = ({ bip44Params, chainId = 1, data, estimatedGas, gasPrice, nonce, to, value, }) => ({
    addressNList: (0, chain_adapters_1.toAddressNList)(bip44Params),
    value: (0, web3_utils_1.numberToHex)(value),
    to,
    chainId,
    data,
    nonce: (0, web3_utils_1.numberToHex)(nonce),
    gasPrice: (0, web3_utils_1.numberToHex)(gasPrice),
    gasLimit: (0, web3_utils_1.numberToHex)(estimatedGas),
});
exports.buildTxToSign = buildTxToSign;
